import React from 'react';

import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";

class TotalCard extends React.Component {
    render() {
        return(
            <Card
                color={this.props.color}
                variant="soft"
                size={'sm'}
                sx={{
                    minWidth: '15%',
                }}
            >
                <CardContent>
                    <Typography
                        level={'body-xs'}
                        sx={{
                            color: ['success', 'primary', 'warning', 'danger'].includes(this.props.color)?null:'white'
                        }}
                    >
                        {this.props.title}
                    </Typography>
                    <Typography
                        sx={{
                            color: ['success', 'primary', 'warning', 'danger'].includes(this.props.color)?null:'white'
                        }}
                    >
                        {this.props.numberFormat.format(this.props.value)}
                    </Typography>
                </CardContent>
            </Card>
        )
    }
}

export default TotalCard